export default __webpack_public_path__ + "static/media/Giro_Pagamentos_2linhas_Principal_FundoClaro.9106736e.png";